import { Condition } from '@/shared/api/protocol-ts/model/dto_report_condition_pb';

export const getConditionModelScorePercentage = (
  condition?: Condition,
): string | undefined => {
  const score = condition?.Certainty?.ModelScore ?? 0;

  if (score > 0 && score <= 0.01) {
    return '~0%';
  }

  if (score > 0.01) {
    return `${Math.trunc(score * 100)}%`;
  }

  return '';
};
